import * as React from "react";
import { Form, Modal } from "antd";
import GenericCodebookItemForm from "./GenericCodebookItemForm";
import { WarningFilled } from "@ant-design/icons";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";
import { TTranslate } from "../../core/service/locale/TranslationService";
import DataGrid from "../../core/ui/components/grid/DataGrid";
import TickBox from "../../core/ui/components/grid/TickBox";

const { confirm } = Modal;

function showWarningModal(
  data: IGenericCodebookItem,
  translate: TTranslate,
  updateGenericCodebookItem: any,
  selectedCodebook?: string
) {
  confirm({
    title: translate("generic_codebook.warning_modal.title"),
    content: (
      <div>
        <p>
          {translate("generic_codebook.warning_modal.message", {
            codebook: selectedCodebook
          })}
        </p>
      </div>
    ),
    icon: <WarningFilled />,
    okText: translate("data_grid.modal.actions.accept"),
    cancelText: translate("data_grid.modal.actions.cancel"),
    onOk() {
      updateGenericCodebookItem(data);
    }
  });
}

const GenericCodebookGrid = ({
  translate,
  updateGenericCodebookItem,
  createGenericCodebookItem,
  selectedCodebook,
  codebookItemList,
  referenceListLoader
}: {
  translate: TTranslate;
  updateGenericCodebookItem: any;
  createGenericCodebookItem: any;
  selectedCodebook?: string;
  codebookItemList?: IGenericCodebookItem[];
  referenceListLoader?: boolean;
}) => {
  const columns = [
    {
      title: translate("generic_codebook.code"),
      dataIndex: "code",
      key: "code",
      width: 100
    },
    {
      title: translate("generic_codebook.value"),
      dataIndex: "value",
      key: "value"
    },
    {
      title: translate("generic_codebook.valid"),
      dataIndex: "valid",
      key: "valid",
      align: "center",
      width: 80,
      render: (text, record) => <TickBox value={record.valid} />
    }
  ];

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  return (
    <DataGrid
      title={translate(`codebooks.${selectedCodebook}`) || selectedCodebook}
      columns={columns}
      translate={translate}
      dataSource={codebookItemList || []}
      createActionPosition="topRight"
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("generic_codebook.add_codebook_item_text")}
      CreateFormInstance={CreateForm}
      createForm={
        <GenericCodebookItemForm
          translate={translate}
          form={CreateForm}
          addNewCodebookItem={true}
        />
      }
      createModalTitle={`${translate(
        "generic_codebook.create_modal_title"
      )} ${translate(`codebooks.${selectedCodebook}`)}`}
      UpdateFormInstance={UpdateForm}
      updateForm={
        <GenericCodebookItemForm
          translate={translate}
          form={UpdateForm}
          addNewCodebookItem={false}
        />
      }
      updateModalTitle={translate("generic_codebook.update_modal_title")}
      loading={referenceListLoader}
      onUpdate={(e) =>
        showWarningModal(
          e,
          translate,
          updateGenericCodebookItem,
          selectedCodebook
        )
      }
      onCreate={createGenericCodebookItem}
      booleanColumnKeys={["valid"]}
      keyProperty={"id"}
    />
  );
};
export default GenericCodebookGrid;
